export const bookmarklet =
  "javascript:(function(){var s=document.createElement('script');s.setAttribute('type','text/javascript');s.setAttribute('charset','UTF-8');s.setAttribute('src','https://www.are.na/loader.js');document.documentElement.appendChild(s);})()"
